module.exports = __webpack_public_path__ + "img/19.207a4210.jpg";